import * as React from "react";

export interface AmazonPaySdkContextValue {
    state: {
        available: boolean;
        linked: boolean;
        isBalanceSufficient: boolean;
        balance?: string;
        isNewSdkAvailable?: boolean;
        wasPreviouslyLinkedUsingSDK?: boolean;
        apl?: {
            linked: boolean;
            creditLimit?: string;
            isCreditLimitSufficient: boolean;
            keyFactStatementUrl?: string;
            disableMessage?: string;
        };
    } | null;
    setState: (state: AmazonPaySdkContextValue["state"]) => void;
    sdkFetchInProgress: boolean;
    setSdkFetchInProgress?: (sdkFetchInProgress: boolean) => void;
}

export const AmazonPaySdkContext = React.createContext<AmazonPaySdkContextValue>({
    state: null,
    setState: () => void 0,
    sdkFetchInProgress: false,
    setSdkFetchInProgress: () => void 0,
});

if (__DEV__) {
    AmazonPaySdkContext.displayName = "AmazonPaySdkContext";
}
